export class PolicyBasicInfo {
    uniqueIdentifier!: string;
    policyNumber!: string;
    contractNumber!: string;

    claimDefinitionId!: number;
    claimDefinitionUniqueCode!: string;
    claimDefinitionVersionCode!: string;
    claimDefinitionName!: string;

    productId!: string;
    productUniqueCode!: string;
    productVersionUniqueCode!: string;

    constructor(data?: any) {
        if (data) {
            this.uniqueIdentifier = data.uniqueIdentifier;
            this.policyNumber = data.policyNumber;
            this.contractNumber = data.contractNumber;

            this.claimDefinitionId = data.claimDefinitionId;
            this.claimDefinitionUniqueCode = data.claimDefinitionUniqueCode;
            this.claimDefinitionVersionCode = data.claimDefinitionVersionCode;
            this.claimDefinitionName = data.claimDefinitionName;

            this.productId = data.productId;
            this.productUniqueCode = data.productUniqueCode;
            this.productVersionUniqueCode = data.productVersionUniqueCode;
        }
    }
}